import { useCallback } from 'react';

import {
  followArticleRequest,
  isFollowingArticleRequest,
  unfollowArticleRequest,
} from '../utils/article-follow-client';

export const useArticleFollow = () => {
  const checkIsFollowing = useCallback(
    (id: string, locale: string): Promise<boolean> =>
      isFollowingArticleRequest(id, locale),
    []
  );

  const follow = useCallback(
    (id: string, locale: string): Promise<unknown> =>
      followArticleRequest(id, locale),
    []
  );

  const unfollow = useCallback(
    (id: string, locale: string): Promise<unknown> =>
      unfollowArticleRequest(id, locale),
    []
  );

  return { checkIsFollowing, follow, unfollow };
};
